import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgPromotion({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.27 3a2.9 2.9 0 012.051.85l6.83 6.829a2.899 2.899 0 010 4.1l-5.372 5.372a2.899 2.899 0 01-4.1 0l-6.83-6.83A2.9 2.9 0 013 11.271V5.899A2.9 2.9 0 015.9 3h5.37zm0 2H5.9a.9.9 0 00-.9.9v5.371a.9.9 0 00.263.636l6.83 6.83a.9.9 0 001.272 0l5.372-5.372a.9.9 0 000-1.272l-6.83-6.83A.9.9 0 0011.27 5zM7.587 7.586a2 2 0 112.828 2.828 2 2 0 01-2.828-2.828z"
        fill={color}
      />
    </svg>
  )
}

export default SvgPromotion
